import { ArrayField, Datagrid, FunctionField, TextField } from 'react-admin';
import { Card, Typography } from '@mui/material';
import classNames from 'classnames';

import DateFieldIgnoringZone from '../../../../components/DateFieldIgnoringZone';
import ResourceGrid from '../../../../components/ResourceGrid';
import { formatCurrency } from '../../../../shared/utils';
import { customerBillingStyle } from './CustomerBillingStyle';

export default function NextCharges({ nextCharges }) {
  const classes = customerBillingStyle();
  const record = {
    next_charges: nextCharges,
  };

  const labelClassName = classNames(classes.label, classes.labelBilling);

  return nextCharges.length ? (
    <>
      <Typography variant='subtitle2' sx={{ margin: '4px 0' }}>
        Upcoming Payments
      </Typography>

      <Card className={classes.billingDetailsCard} variant=''>
        <ResourceGrid record={record}>
          <ArrayField source='next_charges' label=''>
            <Datagrid
              bulkActionButtons={false}
              sx={{
                '& .RaDatagrid-headerCell': {
                  borderBottom: '0px',
                  paddingLeft: '0',
                  paddingRight: '64px',
                },
                '& .RaDatagrid-table': {
                  borderBottom: '0px',
                  width: 'unset',
                },
                '& .RaDatagrid-rowCell': {
                  borderBottom: '0px',
                  paddingLeft: '0',
                  paddingRight: '64px',
                  paddingBottom: '0',
                },
              }}
            >
              <FunctionField
                label={<Typography className={labelClassName}>PETS</Typography>}
                render={nextCharge => `${nextCharge.pet_names.join(', ')}`}
              />
              <TextField
                label={<Typography className={labelClassName}>STATUS</Typography>}
                source='status'
              />
              <TextField
                sx={{ textTransform: 'capitalize' }}
                label={<Typography className={labelClassName}>TYPE</Typography>}
                source='product'
              />

              <DateFieldIgnoringZone
                label={
                  <Typography className={labelClassName}>
                    NEXT CHARGE DATE
                  </Typography>
                }
                source='next_charge_date'
              />
              <FunctionField
                label={<Typography className={labelClassName}>AMOUNT</Typography>}
                render={nextCharge =>
                  `${formatCurrency(nextCharge.amount, { areCents: true })}`
                }
              />
            </Datagrid>
          </ArrayField>
        </ResourceGrid>
      </Card>
    </>
  ) : null;
}
